import { render, staticRenderFns } from "./AdvancedMessageFiltersDialog.vue?vue&type=template&id=8b0840a2&scoped=true&"
import script from "./AdvancedMessageFiltersDialog.vue?vue&type=script&lang=js&"
export * from "./AdvancedMessageFiltersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0840a2",
  null
  
)

export default component.exports